import React from 'react'
import FormField from '../../components/simple/formField/FormField'
import TextArea from '../../components/simple/input/TextArea'

function PILFollowUpFields ({ questions }) {
  return [32, 33].map(index => {
    const question = questions[index]
    return (
      <FormField key={question.key} label={question.questionText} name={question.key}>
        <TextArea name={question.key} />
      </FormField>
    )
  })
}

export default PILFollowUpFields
